import { render, staticRenderFns } from "./apply_basic.vue?vue&type=template&id=24c81b22&scoped=true&"
import script from "./apply_basic.vue?vue&type=script&lang=js&"
export * from "./apply_basic.vue?vue&type=script&lang=js&"
import style0 from "./apply_basic.vue?vue&type=style&index=0&id=24c81b22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c81b22",
  null
  
)

export default component.exports